import React from "react";
import MHEFormFields from "./MHEFormFields";
import {
  Tabs,
  Row,
  Col,
  Checkbox,
  Radio,
  Form,
  Input,
  Button,
  Select,
  Divider,
} from "antd";
import {
  currentPrescriptionTab,
  switchPrescriptionTabs,
} from "store/slice/tabs-slice";
import { setPublishClicked } from "store/slice/videoConsultation-slice";
import { connect } from "react-redux";
import { message } from "antd";
import api from "utils/api";
import Validators from "Common/Validators";
import Loader from "Components/Loader";
import "./VideoConsultation.scss";
import "./PrescriptionTab.scss";
const { TextArea } = Input;
const { TabPane } = Tabs;
import { ArrowRightOutlined } from "@ant-design/icons";
import { DURATION_PERIOD_OPTIONS } from "Common/constant";
const requiredMessage = "This field is required!";
const placeholder = "Type here";

let temp_data_prescription = [];
class YogaTab extends React.Component {
  form = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      temptabs_prescription: [],
      // submit_yoga: false,
      temp_yoga: [],
      temp_diet: [],
      disable_type: false,
      temp_limitations: [],
      submit_diet: false,
      selected_type: "",
      throw_err: false,
      isloading: true,
      med_type: "",
      prescriptionValue: this.props.prescriptionValue,
      selectedTab: "yoga",
      temp_allopathy_data: {},
      wellness_goal: "",
      prescriptions: [],
      allopathy_btn_text: "Submit",
      yoga_btn_text: "Submit",
      diet_btn_text: "Submit",
      enable_measure: false,

      is_prescription: false,
      is_submit: false,
      is_prescription_done: false,
      is_edit: false,
      update_info: false,
      switch_tab: true,
      predefinedPrescription: [],
      predefinedPrescriptionSet: [],
      visible_publish: true,
    };

    //this.updateInfo = this.updateInfo.bind(this);
    //this.switchPrescriptionTabs=this.switchPrescriptionTabs.bind(this)
  }

  handleSubmit(values) {
    const isValidForm =
      Object.entries(values).filter(
        ([key, value]) => value.is_selected !== undefined
      ).length > 0;

    // if (!this.state.submit_yoga) {
    if (!isValidForm) {
      message.error("Cannot submit empty Prescription!", ErrorDuration);
      typeof this.props.formAction == "function" &&
        this.props.formAction(false);
    } else {
      let formData = [];
      let limitations_data = this.state.limitation_list;
      let asans_data = this.state.datau;

      Object.values(limitations_data).map((element) => {
        if (element.limitation_name in values) {
          element.is_selected =
            values[element.limitation_name]["is_selected"] ?? false;
          element.duration =
            values[element.limitation_name]["duration"] ?? null;
          element.duration_period =
            values[element.limitation_name]["duration_period"] ?? "";
        }
      });

      Object.keys(asans_data).map((key) => {
        Object.values(asans_data[key]).map((element) => {
          if (element.asana_name in values) {
            element.is_selected =
              values[element.asana_name]["is_selected"] ?? false;
            element.precautions =
              values[element.asana_name]["precautions"] ?? "";
            element.recommendations =
              values[element.asana_name]["recommendations"] ?? "";
            element.number_of_cycles =
              values[element.asana_name]["number_of_cycles"] ?? "";
          }
        });
      });
      formData = {
        is_completed: true,
        appointment_id: this.props.appointment_id,
        data: {
          limitations: limitations_data,
          asanas: asans_data,
        },
        type: "yoga",
        prescription_mail: false,
        is_prescription_required: true,
      };
      api.submit_prescription(formData).then((res) => {
        if (res.data?.status == 200) {
          this.props.setPublishClicked({ [this.props.appointment_id]: true });
          typeof this.props?.formAction == "function" &&
            this.props.formAction(false);
          typeof this.props?.visiblePublish == "function" &&
            this.props.visiblePublish();
          typeof this.props.handleFunction == "function" &&
            this.props.handleFunction({ is_prescription: true });
          message.success(res.data?.message, ErrorDuration);
          this.setState({ yoga_btn_text: "Update", isloading: false });

          if (this.props?.prescription_enable) {
            this.props.disablePrescription(true);
          }
        }
      });
    }
  }

  getDefaultPrescripitons(yoga) {
    api.get_prescription("yoga").then((res) => {
      this.setState({ data: res.data.data.results[0], update_info: false });

      let { asanas: datau ,limitations:limitation_list} = this.state.data;
      this.setState({ datau: datau ,limitation_list:limitation_list});
    });
    let data = {
      app_id: this.props.appointment_id,
      type: "prescription",
    };
    api.get_consultation_details(data).then((response) => {
      this.setState({ isloading: false });
      if (response.data.data?.results?.prescription.length > 0)
        this.setState({
          response: response.data.data?.results?.prescription[0],
          visible_publish: response.data.data?.results?.prescription[0]
            ?.is_prescription_report
            ? false
            : true,
        });
      if (this.state.response?.is_yoga) {
        this.setState({
          temp_yoga:
            [
              ...this.state.response?.pranayama,
              ...this.state.response?.prone,
              ...this.state.response?.sitting,
              ...this.state.response?.standing,
              ...this.state.response?.supine,
            ] || [],
          temp_limitations: this.state.response.limitations,
        });

        let transformed_limitations = Object.fromEntries(
          this.state.temp_limitations
            .filter((item) => item.is_selected)
            .map(({ limitation_name, ...restValues }) => [
              limitation_name,
              restValues,
            ])
        );

        let transformed_asanas = Object.fromEntries(
          this.state.temp_yoga
            .filter((item) => item.is_selected)
            .map(({ asana_name, ...restValues }) => [asana_name, restValues])
        );

        this.form.current.setFieldsValue({
          ...transformed_limitations,
          ...transformed_asanas,
        });

        if (
           this.state.temp_limitations.length ||
          this.state.temp_yoga.length > 0
        )
          this.setState({ yoga_btn_text: "Update" });
      }
    });
  }

  componentDidMount() {
    typeof this.props.formAction == "function" && this.props.formAction(false);
    this.getDefaultPrescripitons();
  }

  render() {
    return (
      <>
        {this.state.isloading ? (
          <Loader />
        ) : (
          <>
            <Row gutter={24}>
              <Col span={24}>
                <div className="prescription-tab">
                  <Form
                    name="addPrescription"
                    ref={this.form}
                    onFinish={this.handleSubmit.bind(this)}
                    onFieldsChange={() =>
                      typeof this.props.formAction == "function" &&
                      this.props.formAction(true)
                    }
                    labelAlign={"left"}
                    colon={false}
                    scrollToFirstError={{
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }}
                  >
                    <div className="yoga-prescription">
                      <div className="yoga-form">
                        {this.state.isloading ? (
                          <Loader />
                        ) : (
                          <>
                            <p className="yoga-plan-heading">Limitations</p>
                            <div className="limitation-block">
                              {Object.values(
                                this?.state.data?.limitations || {}
                              ).map((item) => {
                                return (
                                  <div className="limitations">
                                    <Col span={24}>
                                      <Form.Item
                                        name={[
                                          item.limitation_name,
                                          "is_selected",
                                        ]}
                                        label={item.limitation_name}
                                        labelCol={{ xs: 17, lg: 16 }}
                                        wrapperCol={{ xs: 7, lg: 8 }}
                                      >
                                        <Radio.Group
                                          disabled={
                                            this.props.prescriptionValue === 1
                                              ? true
                                              : false
                                          }
                                          style={{ marginTop: "4px" }}
                                          options={[
                                            { label: "Yes", value: true },
                                            { label: "No", value: false },
                                          ]}
                                          // onChange={(val) => {
                                          //   //this.updateInfo(val)
                                          //   if (val.target.value == false) {
                                          //     this.form.current.setFieldsValue({
                                          //       [item.limitation_name]: {
                                          //         duration: "",
                                          //         duration_period: "",
                                          //       },
                                          //     });
                                          //   }
                                          // }}
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                      <Form.Item
                                        shouldUpdate={(prevValues, curValues) =>
                                          prevValues[item.limitation_name]
                                            ?.is_selected !==
                                          curValues[item.limitation_name]
                                            ?.is_selected
                                        }
                                      >
                                        {({ getFieldValue }) =>
                                          getFieldValue(item.limitation_name)
                                            ?.is_selected === true ? (
                                            <Col xs={24} xl={24}>
                                              <Form.Item
                                                labelCol={{ md: 8, lg: 10 }}
                                                wrapperCol={{
                                                  md: 16,
                                                  lg: 12,
                                                }}
                                                label="Duration"
                                              >
                                                <Input.Group
                                                  compact
                                                  style={{ display: "flex" }}
                                                >
                                                  <Form.Item
                                                    name={[
                                                      item.limitation_name,
                                                      "duration",
                                                    ]}
                                                    noStyle
                                                    rules={[
                                                      {
                                                        required: getFieldValue(item.limitation_name)?.duration_period?.length>0?true:false,
                                                        message:
                                                          requiredMessage,
                                                      },
                                                      Validators.checkDecimal,
                                                    ]}
                                                  >
                                                    <Input
                                                      disabled={
                                                        this.props
                                                          .prescriptionValue ===
                                                        1
                                                          ? true
                                                          : false
                                                      }
                                                      style={{
                                                        width: "30%",
                                                        height: "32px",
                                                      }}
                                                      maxLength={2}
                                                    />
                                                  </Form.Item>
                                                  <Form.Item
                                                    name={[
                                                      item.limitation_name,
                                                      "duration_period",
                                                    ]}
                                                    noStyle
                                                    rules={[
                                                      {
                                                        required: getFieldValue(item.limitation_name)?.duration?.length>0?true:false,
                                                        message:
                                                          requiredMessage,
                                                      },
                                                    
                                                    ]}
                                                  >
                                                    <Select
                                                      disabled={
                                                        this.props
                                                          .prescriptionValue ===
                                                        1
                                                          ? true
                                                          : false
                                                      }
                                                      style={{ width: "70%" }}
                                                      options={
                                                        DURATION_PERIOD_OPTIONS
                                                      }
                                                      // getPopupContainer={(
                                                      //   trigger
                                                      // ) => trigger.parentNode}
                                                    ></Select>
                                                  </Form.Item>
                                                </Input.Group>
                                              </Form.Item>
                                            </Col>
                                          ) : null
                                        }
                                      </Form.Item>
                                    </Col>
                                  </div>
                                );
                              })}
                            </div>
                            <Divider />
                            <p className="yoga-plan-heading">Asanas</p>
                            <div className="asanas">
                              {Object.keys(this.state?.data?.asanas || {}).map(
                                (formlabel) => {
                                  return (
                                    <>
                                      <div style={{ margin: "10px auto" }}>
                                        <div className="block">
                                          <p>{formlabel.toUpperCase()}</p>
                                          <div className="asana-block">
                                            {Object.values(
                                              this?.state?.data.asanas[
                                                formlabel
                                              ]
                                            ).map((item) => {
                                              return (
                                                <>
                                                  <div
                                                    className="asana-item"
                                                    style={{
                                                      margin: "3px 14px",
                                                    }}
                                                  >
                                                    <Form.Item
                                                      valuePropName="checked"
                                                      labelAlign="left"
                                                      labelCol={{
                                                        xs: 24,
                                                        xl: 20,
                                                      }}
                                                      wrapperCol={{
                                                        xs: 4,
                                                        xl: 8,
                                                      }}
                                                      name={[
                                                        item.asana_name,
                                                        "is_selected",
                                                      ]}
                                                      label={item.asana_name}
                                                    >
                                                      <Checkbox
                                                        style={{
                                                          marginTop: "4px",
                                                        }}
                                                        disabled={
                                                          this.props
                                                            .prescriptionValue ===
                                                          1
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                    </Form.Item>
                                                    <Form.Item
                                                      noStyle
                                                      shouldUpdate={(
                                                        prevValues,
                                                        currentValues
                                                      ) =>
                                                        prevValues[
                                                          item.asana_name
                                                        ]?.is_selected !==
                                                        currentValues[
                                                          item.asana_name
                                                        ]?.is_selected
                                                      }
                                                    >
                                                      {({ getFieldValue }) =>
                                                        getFieldValue(
                                                          item.asana_name
                                                        )?.is_selected ===
                                                        true ? (
                                                          <>
                                                            <Form.Item
                                                              name={[
                                                                item.asana_name,
                                                                "number_of_cycles",
                                                              ]}
                                                              labelCol={{
                                                                span: 13,
                                                              }}
                                                              wrapperCol={{
                                                                span: 9,
                                                              }}
                                                              labelAlign="left"
                                                              rules={[
                                                                {
                                                                  required: false,
                                                                  message:
                                                                    requiredMessage,
                                                                },
                                                                Validators.checkDecimal,
                                                              ]}
                                                              label={
                                                                MHEFormFields[
                                                                  "number_of_cycles"
                                                                ]
                                                              }
                                                            >
                                                              <Input
                                                                disabled={
                                                                  this.props
                                                                    .prescriptionValue ===
                                                                  1
                                                                    ? true
                                                                    : false
                                                                }
                                                                maxLength={3}
                                                              />
                                                            </Form.Item>
                                                            <Form.Item
                                                              name={[
                                                                item.asana_name,
                                                                "precautions",
                                                              ]}
                                                              labelAlign={
                                                                "left"
                                                              }
                                                              labelCol={{
                                                                span: 13,
                                                              }}
                                                              wrapperCol={{
                                                                span: 11,
                                                              }}
                                                              label={
                                                                MHEFormFields[
                                                                  "precautions"
                                                                ]
                                                              }
                                                            >
                                                              <TextArea
                                                                disabled={
                                                                  this.props
                                                                    .prescriptionValue ===
                                                                  1
                                                                    ? true
                                                                    : false
                                                                }
                                                                placeholder={
                                                                  placeholder
                                                                }
                                                              />
                                                            </Form.Item>
                                                            <Form.Item
                                                              name={[
                                                                item.asana_name,
                                                                "recommendations",
                                                              ]}
                                                              labelCol={{
                                                                span: 13,
                                                              }}
                                                              wrapperCol={{
                                                                span: 11,
                                                              }}
                                                              labelAlign="left"
                                                              label={
                                                                MHEFormFields[
                                                                  "recommendations"
                                                                ]
                                                              }
                                                            >
                                                              <TextArea
                                                                disabled={
                                                                  this.props
                                                                    .prescriptionValue ===
                                                                  1
                                                                    ? true
                                                                    : false
                                                                }
                                                                placeholder={
                                                                  placeholder
                                                                }
                                                              />
                                                            </Form.Item>
                                                          </>
                                                        ) : null
                                                      }
                                                    </Form.Item>
                                                  </div>
                                                </>
                                              );
                                            })}
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              )}
                            </div>
                            {(this.state.visible_publish && (this.props?.visible_publish == false ? false : true) && !this.props?.is_prescription_report) ? (
                              <div className="submit-button-wrapper">
                                <Button
                                  className="common-btn"
                                  disabled={
                                    this.props.prescriptionValue === 1
                                      ? true
                                      : false
                                  }
                                  onClick={(e) => {
                                    this.setState({ is_submit: true }),
                                      this.props?.from == "drawer_prescription"
                                        ? this.setState({ isloading: false })
                                        : null,
                                      this.form.current?.submit();
                                  }}
                                >
                                  {this.state.yoga_btn_text}
                                  <ArrowRightOutlined />
                                </Button>
                              </div>
                            ) : null}
                          </>
                        )}
                      </div>
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
          </>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    allow_switchTab: state.tabsReducer.switch_tab,
    switch_prescription_tabs: state.tabsReducer.switch_prescription_tabs,
  };
};
const mapDispatchToProps = {
  switchPrescriptionTabs,
  currentPrescriptionTab,
  setPublishClicked,
};

export default connect(mapStateToProps, mapDispatchToProps)(YogaTab);
